export enum AssetFamilyTypeBatteryBanks {
  LeadAcid = 'lead-acid',
  Lithium = 'lithium',
}
